;(function( window, document, $, undefined ) {
	'use strict';

	// Menu

	function sidebar() {

    // Hide Widget on Mobile
    function hideWidgetMobile( $el, $target ) {
      $('[data-js="hideWidgetMobile"]').each(function(){
        var $this = $(this);
        $this.parents('.widget-item').addClass('hideBelowTablet');
      });
    }

    // Add Widget Above Footer
    function addWidgetAboveFooter( $el, $target ) {
      $('[data-js="addWidgetAboveFooter"]').each(function(){
        var $this = $(this);
        var $clone = $this.clone().addClass('hideAboveMobile');

        $('.footer-widgets').before( $clone );
        $this.parents('.widget-item').addClass('hideBelowMobile');
      });
    }

    // Remove Sidebar Title
    function removeSidebarTitle() {
      $('.genesis-sidebar-title').remove();
    }

		// Globals
		return {
      hideWidgetMobile : hideWidgetMobile,
      addWidgetAboveFooter: addWidgetAboveFooter,
      removeSidebarTitle: removeSidebarTitle
		};

	}

	// Globals
	window.app = window.app || {};
  window.app.sidebar = sidebar();

})( window, document, jQuery );
